<div class="container mt-5 mt-lg-6 d-none d-md-block position-relative z-1" appAos>
    <div class="row">
        <div class="col text-center">
            <img class="w-75" src="assets/images/arrow-curly-down.svg" alt="Curly Arrow" />
        </div>
    </div>
</div>
